import ClassicEditorialTemplate from './templates/ClassicEditorialTemplate';
import BotanicalGardenTemplate from './templates/BotanicalGardenTemplate';
import ModernBlackTieTemplate from './templates/ModernBlackTieTemplate';
import DestinationPraiaTemplate from './templates/DestinationPraiaTemplate';
import MinimalClassicTemplate from './templates/MinimalClassicTemplate';
import VintageRetroTemplate from './templates/VintageRetroTemplate';
import ScandinavianMinimalTemplate from './templates/ScandinavianMinimalTemplate';
import SunsetRomanceTemplate from './templates/SunsetRomanceTemplate';
import NoirDoradoTemplate from './templates/NoirDoradoTemplate';
import TerraFloresTemplate from './templates/TerraFloresTemplate';
import LinhaPuraTemplate from './templates/LinhaPuraTemplate';
import JardimSecretoTemplate from './templates/JardimSecretoTemplate';
import ArtDecoTemplate from './templates/ArtDecoTemplate';
import PraiaBrisaTemplate from './templates/PraiaBrisaTemplate';
import InvernoRealTemplate from './templates/InvernoRealTemplate';
import VeludoRosaTemplate from './templates/VeludoRosaTemplate';
import TipoGiganteTemplate from './templates/TipoGiganteTemplate';
import SakuraTemplate from './templates/SakuraTemplate';
import SerraNevoaTemplate from './templates/SerraNevoaTemplate';
import ParisienseTemplate from './templates/ParisienseTemplate';
import TropicalTemplate from './templates/TropicalTemplate';
import PrataEternoTemplate from './templates/PrataEternoTemplate';
import BohemiaTemplate from './templates/BohemiaTemplate';
import NoiteEstreladaTemplate from './templates/NoiteEstreladaTemplate';
import AzulejoPortuguesTemplate from './templates/AzulejoPortuguesTemplate';

const TEMPLATE_COMPONENTS = {
  'classic-editorial': ClassicEditorialTemplate,
  'botanical-garden': BotanicalGardenTemplate,
  'modern-black-tie': ModernBlackTieTemplate,
  'destination-praia': DestinationPraiaTemplate,
  'minimal-classic': MinimalClassicTemplate,
  'vintage-retro': VintageRetroTemplate,
  'scandinavian-minimal': ScandinavianMinimalTemplate,
  'por-do-sol': SunsetRomanceTemplate,
  'noir-dorado': NoirDoradoTemplate,
  'terra-flores': TerraFloresTemplate,
  'linha-pura': LinhaPuraTemplate,
  'jardim-secreto': JardimSecretoTemplate,
  'art-deco': ArtDecoTemplate,
  'praia-brisa': PraiaBrisaTemplate,
  'inverno-real': InvernoRealTemplate,
  'veludo-rosa': VeludoRosaTemplate,
  'tipo-gigante': TipoGiganteTemplate,
  'sakura': SakuraTemplate,
  'serra-nevoa': SerraNevoaTemplate,
  'parisiense': ParisienseTemplate,
  'tropical': TropicalTemplate,
  'prata-eterno': PrataEternoTemplate,
  'bohemia': BohemiaTemplate,
  'noite-estrelada': NoiteEstreladaTemplate,
  'azulejo-portugues': AzulejoPortuguesTemplate
};

export default function WeddingTemplateRenderer({ templateId, ...props }) {
  const TemplateComponent = TEMPLATE_COMPONENTS[templateId] || ClassicEditorialTemplate;
  return <TemplateComponent {...props} />;
}
